// 事件监听和触发
export default class EventEmit {
  events = [];
  onceEvents = {};

  on(event, callback) {
    this.events[event] = this.events[event] || [];
    const events = this.events[event];
    if (!events.includes(callback)) {
      events.push(callback);
    }
  }

  once(event, callback) {
    this.onceEvents[event] = this.onceEvents[event] || [];
    const events = this.onceEvents[event];
    if (!events.includes(callback)) {
      events.push(callback);
    }
  }

  off(event, callback) {
    if (!callback) {
      this.events[event] = [];
      return;
    }
    const events = this.events[event] || [];
    const idx = events.findIndex(i => i === callback);
    if (idx > -1) {
      events.splice(idx, 1);
    }
  }

  emit(event, ...args) {
    const events = this.events[event] || [];
    events.forEach(callback => {
      callback(...args);
    });
    const events2 = this.onceEvents[event] || [];
    events2.forEach(callback => {
      callback(...args);
      const idx = events2.findIndex(i => i === callback);
      if (idx > -1) {
        events2.splice(idx, 1);
      }
    });
  }
}
